export default __webpack_public_path__ + "static/media/secondary.4195d967.png";